import { forwardRef, createElement } from 'react';

function IconCashAccount(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M20 8a2 2 0 012 2v9a2 2 0 01-2 2H8a2 2 0 01-2-2v-9a2 2 0 012-2h12zm.5 5h-13v6a.5.5 0 00.41.492L8 19.5h12a.5.5 0 00.492-.41L20.5 19v-6zM12 15a.5.5 0 01.5.5V17a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1.5a.5.5 0 01.5-.5h2zm4.607-10.568L17.294 7h-1.553l-.583-2.18a.5.5 0 00-.524-.369l-.089.016L3.92 7.314a.5.5 0 00-.369.523l.016.089L5 13.276v3.905a1.992 1.992 0 01-.812-1.14l-2.07-7.727a2 2 0 011.414-2.45l10.625-2.846a2 2 0 012.45 1.414zM20 9.5H8a.5.5 0 00-.492.41L7.5 10v1.5h13V10a.5.5 0 00-.41-.492L20 9.5z",
    fill: "currentColor"
  }));
}

var CashAccount = /*#__PURE__*/forwardRef(IconCashAccount);

export default CashAccount;
//# sourceMappingURL=CashAccount.js.map
